import { render, staticRenderFns } from "./PublishedModal.vue?vue&type=template&id=48d54458&"
import script from "./PublishedModal.vue?vue&type=script&lang=js&"
export * from "./PublishedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports